import { useEffect, useRef, useState } from "react";
import { CustomLoader } from "../../../shared/components/custom-loader/custom-loader";
import { FormInput } from "../../../shared/components/form-component/form-input";
import { SERVICES } from "../../../core/services/services";
import { CustomToast } from "../../../shared/components/alert/custom-toast";
import { CUSTOM_VALIDATION } from "../../../shared/validation/validation";
import { CustomMessage } from "../../../shared/components/alert/custom-message";
import { HELPER } from "../../../shared/helper/helper";
import { Toast } from "primereact/toast";
import { API } from "../../../core/apis/apis";

export function MerchantCategoryForm(props) {
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [messageTitle, setMessageTitle] = useState(null);
  const [message, setMessage] = useState(null);
  const [validForm, setValidForm] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [merchantCategory, setMerchantCategory] = useState({
    name: null,
    code: null,
  });
  const [formErrors, setFormErrors] = useState({
    name: null,
    code: null,
  });

  useEffect(() => {
    if (props.isUpdate) {
      const { name, code } = props.merchantCategory;
      setMerchantCategory({
        name,
        code,
      });
    }
  }, [props.isUpdate, props.merchantCategory]);

  useEffect(() => {
    function checkValidForm() {
      const validForm = CUSTOM_VALIDATION.IS_VALID_FORM(merchantCategory);
      const validErrorForm = !CUSTOM_VALIDATION.VALID_OBJ_ANY(formErrors);
      setValidForm(validForm && validErrorForm);
    }
    checkValidForm();
  }, [merchantCategory, formErrors]);

  function validateForm(e, name, type, refineName, required) {
    let value = e?.target?.value;
    const isEmpty = CUSTOM_VALIDATION.IS_EMPTY(value);
    const isValidInput = !isEmpty
      ? CUSTOM_VALIDATION.BASIC_VALIDATION(value, type)
      : false;

    if (isValidInput) {
      setMerchantCategory({ ...merchantCategory, [name]: value });
      setFormErrors({ ...formErrors, [name]: null });
    } else {
      let errorMessage =
        required && isEmpty ? `${refineName} is required` : null;
      if (!isValidInput) {
        errorMessage = `${refineName} is invalid`;
      }
      setFormErrors({
        ...formErrors,
        [name]: errorMessage,
      });
    }
  }

  function submit() {
    setLoading(true);
    const SERVICE = props.isUpdate
      ? SERVICES.MAKE_PUT_REQUEST
      : SERVICES.MAKE_POST_REQUEST;
    const url = props.isUpdate
      ? `${API.MERCHANT_CATEGORIES}/update`
      : API.MERCHANT_CATEGORIES;

    SERVICE(url, merchantCategory)
      .then((data) => {
        setMessageTitle(null);
        setResponseMessage(
          `Merchant category ${
            props.isUpdate ? "updated" : "created"
          } successfully`
        );
        setCurrentIndex(1);
        setLoading(false);
      })
      .catch((error) => {
        setMessageTitle("Error");
        setMessage(HELPER.PROCESS_ERROR(error));
        setLoading(false);
      });
  }

  function closeModal(reload) {
    if (reload === true) {
      let resetPageNo = props.isUpdate ? false : true;
      props.closeModal(reload, resetPageNo);
    } else {
      props.closeModal();
    }
  }

  const cancelButton = () => {
    if (!loading) {
      return (
        <button onClick={closeModal} className="secondary-button">
          Cancel
        </button>
      );
    } else {
      return <div />;
    }
  };

  const submitButton = () => {
    if (!loading) {
      return (
        <button
          disabled={!validForm}
          onClick={submit}
          className="primary-button"
        >
          Submit
        </button>
      );
    } else {
      return (
        <div className="pull-up-element-2 p-mt-3">
          <CustomLoader loadingText="Submitting..." />
        </div>
      );
    }
  };

  const renderForm = () => {
    switch (currentIndex) {
      case 0:
        return <div>{formView()}</div>;
      case 1:
        return (
          <div>
            <div>
              <CustomMessage
                closeModal={closeModal}
                close={true}
                message={responseMessage}
                messageType="success"
              />
            </div>
          </div>
        );
      default:
        return;
    }
  };

  const viewAlert = () => {
    if (messageTitle) {
      return (
        <div>
          <CustomToast
            title={messageTitle}
            description={message}
            type="error"
          />
        </div>
      );
    } else {
      return <div />;
    }
  };

  const formView = () => {
    return (
      <div>
        <div className="custom-modal-title p-text-left">{`${
          props.isUpdate ? "Update" : "Create"
        } Merchant Category`}</div>
        <div className="custom-dialog-subtitle-container p-mb-5">
          <p className="custom-dialog-subtitle">{`Fill the form below to ${
            props.isUpdate ? "update" : "create"
          } merchant category`}</p>
          <p className="custom-dialog-subtitle">* Required Fields</p>
        </div>
        <div className="p-grid">
          <div className="p-col-12">
            <FormInput
              value={merchantCategory["name"]}
              required={true}
              field="name"
              type="NAME"
              error={formErrors["name"]}
              fn={validateForm}
              loading={loading}
              placeholder="Name"
            />
          </div>
          <div className="p-col-12">
            <FormInput
              value={merchantCategory["code"]}
              required={true}
              field="code"
              type="CODE"
              error={formErrors["code"]}
              fn={validateForm}
              // loading={loading}
              disabled={props.isUpdate}
              placeholder="Code (Max Length. 10)"
            />
          </div>
          <div className="p-col-12">
            <div>{viewAlert()}</div>
          </div>
          <div className="p-col-12">
            <div className="p-mt-2">
              <div className="p-grid">
                <div className={loading ? "p-col-12" : "p-col-6"}>
                  {cancelButton()}
                </div>
                <div className={loading ? "p-col-12" : "p-col-6"}>
                  {submitButton()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div>
        <Toast ref={toast} />
      </div>
      <div className="p-pb-2">{renderForm()}</div>
    </div>
  );
}
